let elements;


//Check if Page loaded
document.addEventListener("turbolinks:load", function () {
  if (window.payment_intent_client_secret) {
    const urlParams = new URLSearchParams(window.location.search);
    const view = urlParams.get('view');
    window.payment_success_url.searchParams.append("payment_status", "completed");
    if (view) {
      window.payment_success_url.searchParams.append("view", view);
    }
    var notice_field = document.getElementById("notice");
    initialize_apple_google_pay();
    initialize();
    document.querySelector("#payment-form").addEventListener("submit", handleSubmit);
    checkStatus();
  }
})

async function initialize_apple_google_pay() {
  var paymentRequest = stripe.paymentRequest({
    country: 'DE',
    currency: 'eur',
    total: {
      label: window.product_name,
      amount: window.product_price_in_cents,
    },
    displayItems: window.order_products,
    requestPayerName: true,
    requestPayerEmail: true,
  });

  var elements = stripe.elements({ locale: 'de' });
  var prButton = elements.create('paymentRequestButton', {
    paymentRequest: paymentRequest,
  });
  paymentRequest.canMakePayment().then(function (result) {
    if (result) {
      document.getElementById("agb_apple_pay_notice").style.display = 'inline-block';
      prButton.mount('#payment-request-button');
    } else {
      document.getElementById('payment-request-button').style.display = 'none';
    }
  });


  paymentRequest.on('paymentmethod', function (ev) {
    stripe.confirmCardPayment(
      payment_intent_client_secret,
      { payment_method: ev.paymentMethod.id },
      { handleActions: false }
    ).then(function (confirmResult) {
      if (confirmResult.error) {
        notice_field.innerText = "Error: Etwas hat bei der Zahlung nicht geklappt, bitte versuchen Sie eine andere Zahlmethode";
        ev.complete('fail');
      } else {
        ev.complete('success');
        card_payment_success_url = window.payment_success_url;
        card_payment_success_url.searchParams.append("payment_intent", confirmResult.paymentIntent.id);
        card_payment_success_url.searchParams.append("payment_intent_client_secret", payment_intent_client_secret);
        if (confirmResult.paymentIntent.status === "requires_action") {
          stripe.confirmCardPayment(payment_intent_client_secret).then(function (result) {
            if (result.error) {
              notice_field.innerText = "Error: Etwas hat bei der Zahlung nicht geklappt, bitte versuchen Sie eine andere Zahlmethode";
            } else {
              window.location.replace(card_payment_success_url);
            }
          });
        } else {
          window.location.replace(card_payment_success_url);
        }
      }
    });
  });
}

// Fetches a payment intent and captures the client secret
async function initialize() {
  const appearance = {
    theme: 'stripe',
  };
  elements = stripe.elements({ appearance, clientSecret: payment_intent_client_secret });
  const paymentElement = elements.create('payment', {
    layout: {
      type: 'accordion',
      defaultCollapsed: false,
      radios: false,
      spacedAccordionItems: false,
    },
    wallets: {
      applePay: 'never',
      googlePay: 'never'
    }
  });
  paymentElement.mount("#payment-element");
}

async function handleSubmit(e) {
  e.preventDefault();
  setLoading(true);
  const { error } = await stripe.confirmPayment({
    elements,
    confirmParams: {
      return_url: window.payment_success_url.toString(),
    },
  });

  if (error.type === "card_error" || error.type === "validation_error") {
    showMessage(error.message);
  } else {
    showMessage("An unexpected error occurred.");
  }
  setLoading(false);
}


// Fetches the payment intent status after payment submission
async function checkStatus() {
  const clientSecret = new URLSearchParams(window.location.search).get(
    "payment_intent_client_secret"
  );
  if (!clientSecret) {
    return;
  }
  const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);

  switch (paymentIntent.status) {
    case "succeeded":
      showMessage("Zahlung war erfolgreich!");
      break;
    case "processing":
      showMessage("Ihre Zahlung ist in arbeit!");
      break;
    case "requires_payment_method":
      showMessage("Ihre Zahlung war nicht erfolgreich, bitte versuchen Sie es erneut!");
      break;
    default:
      showMessage("Etwas ist schief gelaufen!");
      break;
  }
}

// ------- UI helpers -------

function showMessage(messageText) {
  const messageContainer = document.querySelector("#payment-message");

  messageContainer.classList.remove("hidden");
  messageContainer.textContent = messageText;

  setTimeout(function () {
    messageContainer.classList.add("hidden");
    messageText.textContent = "";
  }, 4000);
}

// Show a spinner on payment submission
function setLoading(isLoading) {
  if (isLoading) {
    // Disable the button and show a spinner
    document.querySelector("#submit").disabled = true;
    document.querySelector("#spinner").classList.remove("hidden");
    document.querySelector("#button-text").classList.add("hidden");
  } else {
    document.querySelector("#submit").disabled = false;
    document.querySelector("#spinner").classList.add("hidden");
    document.querySelector("#button-text").classList.remove("hidden");
  }
}
